import React from 'react';
import { Form, Input } from '../../../../../components';
import classNames from 'classnames';

export const SourceWorkerInputFields = ({ sourceWorkerIndex, vmLevelEnabled, inWorkerTab = false }) => {
    const name = (field) => ['sourceWorkers', sourceWorkerIndex, field];

    return (
        <>
            <Form.Item
                label="Source Worker VM Name"
                name={name('vmName')}
                rules={[{ required: vmLevelEnabled, message: 'Please enter source worker name' }]}
            >
                <Input placeholder="Enter a Source Worker VM Name" />
            </Form.Item>

            <Form.Item
                label="Datacenter Name"
                name={name('datacenterName')}
                rules={[{ required: vmLevelEnabled, message: 'Please enter datacenter name' }]}
            >
                <Input placeholder="Enter a Datacenter Name" />
            </Form.Item>

            <Form.Item
                label="Cluster Name"
                name={name('clusterName')}
                rules={[{ required: vmLevelEnabled, message: 'Please enter cluster name' }]}
            >
                <Input placeholder="Enter a Cluster Name" />
            </Form.Item>

            <Form.Item
                label="Datastore Name"
                name={name('datastoreName')}
                rules={[{ required: vmLevelEnabled, message: 'Please enter datastore name' }]}
            >
                <Input placeholder="Enter a Datastore Name" />
            </Form.Item>

            <Form.Item label="Resource Pool Name (optional)" name={name('resourcePoolName')}>
                <Input placeholder="Enter a Resource Pool Name (optional)" />
            </Form.Item>

            <Form.Item
                label="Folder Name (optional)"
                name={name('folderName')}
                className={classNames('source-worker-fields__folder', {
                    'source-worker-fields__folder--in-tab': inWorkerTab,
                })}
            >
                <Input placeholder="Enter a Folder Name (optional)" />
            </Form.Item>
        </>
    );
};

